/**
 * Onboarding tracker API. Fetch/update failures return { Error } and never throw.
 * Callers must not block UI or change user flow on failure.
 */
import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';

const updateEndpoint = 'onboardingTracker/';
const fetchEndpoint = 'fetchOnboardingTracker/';
const updateUrl = apiUrl + updateEndpoint;
const fetchUrl = apiUrl + fetchEndpoint;

export interface OnboardingTrackerRequest {
  UserUUID: string;
  OrgUUID?: string;
  GitHubUsername?: string;
  GitLabUsername?: string;
  LastCompletedStep?: string;
}

export interface OnboardingTrackerResponse {
  UserUUID?: string;
  OrgUUID?: string;
  GitHubUsername?: string;
  GitLabUsername?: string;
  CreatedAt?: string;
  LastCompletedStep?: string;
  Exists?: boolean;
  Deleted?: boolean;
  Error?: string | null;
}

export const updateOnboardingTracker = async (
  req: OnboardingTrackerRequest
): Promise<OnboardingTrackerResponse> => {
  try {
    const res = await postWithAuth(updateUrl, req);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = typeof text === 'string' ? JSON.parse(text) : text;
    return data as OnboardingTrackerResponse;
  } catch {
    return { Error: 'An unexpected error occurred' };
  }
};

export const fetchOnboardingTracker = async (
  req: Omit<OnboardingTrackerRequest, 'LastCompletedStep'>
): Promise<OnboardingTrackerResponse> => {
  try {
    const res = await postWithAuth(fetchUrl, req);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = typeof text === 'string' ? JSON.parse(text) : text;
    return data as OnboardingTrackerResponse;
  } catch {
    return { Error: 'An unexpected error occurred' };
  }
};
